export const SOLO_ALBUMS = [
  {
    artist: 'Carl Hauck',
    title: 'Death Farm',
    year: '2025',
    iconAriaLabel: 'Death Farm on Bandcamp',
    url: 'https://carlhauck.bandcamp.com/album/death-farm',
    imageSrc: '/images/ch_death-farm_bc.jpg',
  },
  {
    artist: 'Carl Hauck',
    title: 'Vestige',
    year: '2017',
    iconAriaLabel: 'Vestige on Bandcamp',
    url: 'https://carlhauck.bandcamp.com/album/vestige',
    imageSrc: '/images/ch_vestige_bc.jpg',
  },
  {
    artist: 'Carl Hauck',
    title: 'Windjammer',
    year: '2010',
    iconAriaLabel: 'Windjammer on Bandcamp',
    url: 'https://carlhauck.bandcamp.com/album/windjammer',
    imageSrc: '/images/ch_windjammer_bc.jpg',
  },
  {
    artist: 'Carl Hauck',
    title: 'Counter Intelligence',
    year: '2008',
    iconAriaLabel: 'Counter Intelligence on Bandcamp',
    url: 'https://carlhauck.bandcamp.com/album/counter-intelligence',
    imageSrc: '/images/ch_counter-intelligence_bc.jpg',
  },
  {
    artist: 'Carl Hauck',
    title: 'Something to Laugh About',
    year: '2005',
    imageSrc: '/images/ch_something-to-laugh-about_bc.jpg',
  },
  {
    artist: 'Carl Hauck',
    title: 'Carl Hauck',
    year: '2004',
    imageSrc: '/images/ch_carl-hauck_bc.jpg',
  }
];

export const SUNJACKET_ALBUMS = [
  {
    artist: 'Various Artists / Sunjacket',
    title: 'More Like Life',
    year: '2023',
    iconAriaLabel: "Sunjacket's More Like Life on Bandcamp",
    url: 'https://sunjacket.bandcamp.com/album/more-like-life',
    imageSrc: '/images/sj_more-like-life_bc.jpg',
  },
  {
    artist: 'Sunjacket',
    title: 'More Lifelike',
    year: '2021',
    iconAriaLabel: "Sunjacket's More Lifelike on Bandcamp",
    url: 'https://sunjacket.bandcamp.com/album/more-lifelike',
    imageSrc: '/images/sj_more-lifelike_bc.jpg',
  },
  {
    artist: 'Sunjacket',
    title: 'Mantra',
    year: '2016',
    iconAriaLabel: "Sunjacket's Mantra on Bandcamp",
    url: 'https://sunjacket.bandcamp.com/album/mantra',
    imageSrc: '/images/sj_mantra_bc.jpg',
  },
];

export const OTHER = [
  {
    artist: 'Various Artists',
    title: 'Never Give Up: Celebrating 10 Years of The Postal Service',
    year: '2013',
    imageSrc: '/images/va_postal-service_bc.jpg',
  },
  {
    artist: 'Carl Hauck',
    title: 'Audiotree Live',
    year: '2012',
    imageSrc: '/images/ch_audiotree-live_bc.jpg',
  },
  {
    artist: 'Carl Hauck',
    title: 'Going',
    year: '2012',
    iconAriaLabel: 'Going on Bandcamp',
    url: 'https://carlhauck.bandcamp.com/track/going',
    imageSrc: '/images/ch_going_bc.jpg',
  },
  {
    artist: 'Various Artists',
    title: 'Seven Swans Reimagined',
    year: '2011',
    iconAriaLabel: 'Seven Swans Reimagined on Bandcamp',
    url: 'https://onjoyfulwings.bandcamp.com/album/seven-swans-reimagined',
    imageSrc: '/images/va_seven-swans-reimagined_bc.jpg',
  },
  {
    artist: 'Carl Hauck',
    title: 'Windjammer B-Sides',
    year: '2010',
    iconAriaLabel: 'Windjammer B-Sides on Bandcamp',
    url: 'https://carlhauck.bandcamp.com/album/windjammer-b-sides-2',
    imageSrc: '/images/ch_windjammer-b-sides_bc.jpg',
  },
  {
    artist: 'Various Artists',
    title: 'We Were Lost, We Were Free',
    year: '2010',
    iconAriaLabel: 'We Were Lost, We Were Free on Bandcamp',
    url: 'https://onjoyfulwings.bandcamp.com/album/we-were-lost-we-were-free',
    imageSrc: '/images/va_we-were-lost-we-were-free_bc.jpg',
  },
]
